export const BUSINESS_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  FREELANCER: 'FREELANCER',
};

export const VERIFY_TYPE = {
  SIGN_UP: 'SIGN_UP',
  FIND_PASSWORD: 'FIND_PASSWORD',
};
